import { EditIcon } from "~/assets/icons";
import styles from "./EstimateStep6.module.scss";
import classNames from "classnames/bind";
import { useState, useRef, useEffect } from "react";
import FormInput from "~/components/common/form/formInput/FormInput";
import { EstimateModeViewEnum } from "~/pages/admin/jobs/add-job/constants/add-estimate.constants";
import FormInpuEditor from "~/components/common/form/formInpuEditor/FormInpuEditor";
import TitleEditor from "~/components/common/form/titleEdit/TitleEditor";
import { useAppDispatch, useAppSelector } from "~/redux/hooks";
import { handleGetEstimateTemplateIntroduction } from "~/thunks/estimate-setting/estimateSettingThunk";
import { IEstimateTemplateIntroduction } from "~/utils/interface/estimateSetting";
import { applyEstimateTemplatePlaceholders } from "../../applyEstimateTemplatePlaceholders";

const cx = classNames.bind(styles);

interface EstimateStep6Props {
    onChange: (formData: any) => void,
    data: any,
    mode: string,
    errorForm: any,
    onPreview: () => void,
    salesRep?: any,
}

const EstimateStep6 = ({
    onChange,
    data,
    mode,
    errorForm,
    onPreview,
    salesRep,
}: EstimateStep6Props) => {
    const dispatch = useAppDispatch();
    const { estimateTemplateIntroduction } = useAppSelector((state) => state.estimateSetting);

    const [formData, setFormData] = useState<{
        termsNConditions: string;
        titleStep6: string;
    }>(data);

    const [error, setError] = useState({
        termsNConditions: '',
    });

    const [templateDropdownOpen, setTemplateDropdownOpen] = useState(false);
    const [templatesLoading, setTemplatesLoading] = useState(false);
    const templateDropdownRef = useRef<HTMLDivElement>(null);
    const formDataRef = useRef(formData);

    useEffect(() => {
        formDataRef.current = formData;
    }, [formData]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (templateDropdownRef.current && !templateDropdownRef.current.contains(event.target as Node)) {
                setTemplateDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleUpdateData = (update: any) => {
        const next = { ...formDataRef.current, ...update };
        formDataRef.current = next;
        onChange(next);
        setFormData(next);
    };

    const handleUseTemplateClick = () => {
        const nextOpen = !templateDropdownOpen;
        setTemplateDropdownOpen(nextOpen);
        if (nextOpen) {
            setTemplatesLoading(true);
            dispatch(handleGetEstimateTemplateIntroduction()).finally(() => {
                setTemplatesLoading(false);
            });
        }
    };

    const handleSelectTemplate = (template: IEstimateTemplateIntroduction) => {
        handleUpdateData({
            titleStep6: template.estimateTemplate.templateName ?? "",
            termsNConditions: applyEstimateTemplatePlaceholders(
                template.estimateTemplate.templateDescription ?? "",
                data?.firstName,
                salesRep,
            ),
        });
        setTemplateDropdownOpen(false);
    };

    return (<div className={cx('estimate-step-container')}>
        <div className={cx('header', 'flex items-center justify-between')}>
            <TitleEditor value={formData.titleStep6}
                name={""}
                placeholder={""}
                inputkey={""}
                isViewMode={mode == EstimateModeViewEnum.VIEW}
                onChange={(value) => {
                    handleUpdateData({ titleStep6: value });
                }}
                styleView={{
                    fontSize: "20px",
                    fontWeight: 700,
                }}
            />
            <div className="flex items-center gap-[16px]" ref={templateDropdownRef}>
                <div className={cx("template-dropdown-wrapper")}>
                    <button
                        type="button"
                        onClick={handleUseTemplateClick}
                        className={cx('use-template')}
                    >
                        Use Template
                    </button>
                    {templateDropdownOpen && (
                        <div className={cx("template-dropdown")}>
                            {templatesLoading ? (
                                <div className={cx("template-dropdown-loading")}>
                                    Loading...
                                </div>
                            ) : (
                                <ul className={cx("template-dropdown-list")}>
                                    {estimateTemplateIntroduction.length === 0 ? (
                                        <li className={cx("template-dropdown-empty")}>No templates</li>
                                    ) : (
                                        estimateTemplateIntroduction.map((template) => (
                                            <li key={template.id}>
                                                <button
                                                    type="button"
                                                    className={cx("template-dropdown-item")}
                                                    onClick={() => handleSelectTemplate(template)}
                                                >
                                                    {template.estimateTemplate.templateName || "Unnamed template"}
                                                </button>
                                            </li>
                                        ))
                                    )}
                                </ul>
                            )}
                        </div>
                    )}
                </div>

                <button onClick={onPreview} className={cx('btn-preview')}>
                    View Page
                </button>
            </div>
        </div>
        <div className={cx('content')}>
            <div className="w-full flex items-center justify-between mb-[16px]">
                <p className="text-[#F9FBFE] font-[500] font-[14px] leading-[21px]">Terms and Conditions</p>
                {/* <button 
                        className={cx("left-content-body-menu-item")}>
                            Use Template
                    </button> */}
            </div>
            {
                mode == EstimateModeViewEnum.VIEW ?
                    (<>
                        <div className={cx('title-preview')}>Terms & Condition</div>
                        <div className={cx("text-preview")}>
                            <div
                                dangerouslySetInnerHTML={{ __html: formData.termsNConditions }}
                            />
                        </div>
                    </>) :
                    (
                        <FormInpuEditor
                            name={"companyDescription"}
                            text={""}
                            isViewMode={mode == EstimateModeViewEnum.VIEW}
                            placeholder={""}
                            inputkey={"companyDescription"}
                            value={formData.termsNConditions}
                            errorMessage={errorForm.termsNConditions}
                            height="200px"
                            onChange={(value) => {
                                handleUpdateData({ termsNConditions: value });
                            }}
                        />
                    )
            }

        </div>
    </div>)
}

export default EstimateStep6;